import React from 'react';
import { Skeleton, Card, Row, Col } from 'antd';

const ProfileSkeleton = () => {
    return (
        <div className="unified-profile-page pcu-max-w-900 pcu-margin-x-auto pcu-padding-20">
            {/* Header Skeleton */}
            <Card className="profile-header-card pcu-margin-bottom-24 pcu-radius-16 pcu-overflow-hidden">
                <div className="profile-cover-gradient pcu-h-120 pcu-bg-muted"></div>
                <div className="profile-header-content pcu-padding-x-24">
                    <div className="avatar-wrapper pcu-pos-relative pcu-margin-top-minus-60 pcu-margin-bottom-16">
                        <Skeleton.Avatar active size={120} shape="circle" />
                    </div>
                    <div className="pcu-flex-1 pcu-padding-bottom-10">
                        <Skeleton active paragraph={{ rows: 1 }} title={{ width: 250 }} />
                        <div className="pcu-flex pcu-gap-8 pcu-margin-top-10">
                            <Skeleton.Button active size="small" className="pcu-w-80" />
                            <Skeleton.Button active size="small" className="pcu-w-100" />
                            <Skeleton.Button active size="small" className="pcu-w-70" />
                        </div>
                    </div>
                </div>
            </Card>

            {/* Tabs & Content Skeleton */}
            <Card className="pcu-radius-16">
                <div className="pcu-margin-bottom-24">
                    <Skeleton.Button active size="default" className="pcu-w-100 pcu-margin-right-20" />
                    <Skeleton.Button active size="default" className="pcu-w-100 pcu-margin-right-20" />
                    <Skeleton.Button active size="default" className="pcu-w-100" />
                </div>
                <Row gutter={[24, 24]}>
                    <Col xs={24} md={12}><Skeleton active paragraph={{ rows: 2 }} /></Col>
                    <Col xs={24} md={12}><Skeleton active paragraph={{ rows: 2 }} /></Col>
                    <Col xs={24} md={12}><Skeleton active paragraph={{ rows: 2 }} /></Col>
                    <Col xs={24} md={12}><Skeleton active paragraph={{ rows: 2 }} /></Col>
                </Row>
            </Card>
        </div>
    );
};

export default ProfileSkeleton;
